import { render, staticRenderFns } from "./setBenefits.vue?vue&type=template&id=5645448f&scoped=true"
import script from "./setBenefits.vue?vue&type=script&lang=js"
export * from "./setBenefits.vue?vue&type=script&lang=js"
import style0 from "./setBenefits.vue?vue&type=style&index=0&id=5645448f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5645448f",
  null
  
)

export default component.exports